(() => {
  // node_modules/@fluejs/noscroll/dist/shared/noscroll.96a94b32.mjs
  var isBody = (target) => target === document.body;
  var attrAsSelector = (attr) => `[${attr}]`;
  var getScrollbarWidth = (target) => {
    if (isBody(target)) {
      const documentWidth = document.documentElement.clientWidth;
      const windowWidth = window.innerWidth;
      return windowWidth - documentWidth;
    }
    const borderLeftWidthSavedValue = target.style.borderLeftWidth;
    const borderRightWidthSavedValue = target.style.borderRightWidth;
    target.style.borderLeftWidth = "0px";
    target.style.borderRightWidth = "0px";
    const scrollbarWidth = target.offsetWidth - target.clientWidth;
    target.style.borderLeftWidth = borderLeftWidthSavedValue;
    target.style.borderRightWidth = borderRightWidthSavedValue;
    return scrollbarWidth;
  };
  var asArray = (data) => {
    if (Array.isArray(data)) {
      return data;
    }
    return [data];
  };
  function throttle(fn, wait) {
    let inThrottle;
    let lastFn;
    let lastTime;
    return (...args) => {
      if (!inThrottle) {
        fn(...args);
        lastTime = Date.now();
        inThrottle = true;
      } else {
        clearTimeout(lastFn);
        lastFn = setTimeout(() => {
          if (Date.now() - lastTime >= wait) {
            fn(...args);
            lastTime = Date.now();
          }
        }, Math.max(wait - (Date.now() - lastTime), 0));
      }
    };
  }
  var createQueue = (onInit, onReset, onClear) => {
    let counter = 0;
    let isInitCalled = false;
    const init = () => {
      if (counter <= 0) {
        onInit();
        isInitCalled = true;
      }
      counter += 1;
    };
    const reset = () => {
      if (counter > 0) {
        counter -= 1;
      }
      if (counter <= 0 && isInitCalled) {
        onReset();
      }
    };
    const clearAndReset = () => {
      counter = 0;
      isInitCalled = false;
      onClear == null ? void 0 : onClear();
      onReset();
    };
    const initIsCalled = () => isInitCalled;
    return {
      init,
      reset,
      clearAndReset,
      initIsCalled
    };
  };
  var NoScrollAttrs = {
    SCROLL_DISABLED: "data-noscroll-target-scroll-disabled",
    // scrollbar width adjustment for an element with a disabled scrollbar.
    SCROLL_SCROLLBAR_WIDTH_ADJUSTMENT: "data-noscroll-target-scroll-scrollbar-width-adjustment",
    SCROLLBAR_WIDTH_ADJUSTMENT: "data-noscroll-target-scrollbar-width-adjustment",
    SCROLLABLE: "data-noscroll-target-scrollable",
    GLOBAL_STYLES: "data-noscroll-global-styles"
  };
  var NoScrollCssVars = {
    TARGET_SCROLLBAR_WIDTH: "--noscroll-target-scrollbar-width",
    TARGET_PADDING_RIGHT: "--noscroll-target-padding-right"
  };
  var DEFAULT_WINDOW_RESIZE_THROTTLE = 200;

  // node_modules/@fluejs/noscroll/dist/index.mjs
  var appendGlobalStyles = () => {
    if (document.querySelector(attrAsSelector(NoScrollAttrs.GLOBAL_STYLES))) {
      return;
    }
    const scrollDisabledSelector = attrAsSelector(NoScrollAttrs.SCROLL_DISABLED);
    const scrollbarWidthAdjustmentSelector = attrAsSelector(NoScrollAttrs.SCROLLBAR_WIDTH_ADJUSTMENT);
    const scrollScrollbarWidthAdjustmentSelector = attrAsSelector(NoScrollAttrs.SCROLL_SCROLLBAR_WIDTH_ADJUSTMENT);
    const css = `    
    ${scrollDisabledSelector} {
        overflow: hidden !important;
    }
    
    ${scrollDisabledSelector} ${scrollbarWidthAdjustmentSelector},
    ${scrollDisabledSelector}${scrollScrollbarWidthAdjustmentSelector} {
        padding-right: calc(var(${NoScrollCssVars.TARGET_PADDING_RIGHT}) + var(${NoScrollCssVars.TARGET_SCROLLBAR_WIDTH})) !important;
    }
    `;
    const styleEl = document.createElement("style");
    styleEl.setAttribute(NoScrollAttrs.GLOBAL_STYLES, "");
    styleEl.appendChild(document.createTextNode(css));
    document.head.appendChild(styleEl);
  };
  var createNoScroll = (options) => {
    var _a;
    const adjustScrollbarWidth2 = (target) => {
      asArray(target).forEach((el) => {
        el.removeAttribute(NoScrollAttrs.SCROLLBAR_WIDTH_ADJUSTMENT);
        const computedStyle = window.getComputedStyle(el);
        el.style.setProperty(NoScrollCssVars.TARGET_PADDING_RIGHT, computedStyle.paddingRight);
        el.setAttribute(NoScrollAttrs.SCROLLBAR_WIDTH_ADJUSTMENT, "");
      });
    };
    const removeScrollbarWidthAdjustment2 = (target) => {
      asArray(target).forEach((el) => {
        el.removeAttribute(NoScrollAttrs.SCROLLBAR_WIDTH_ADJUSTMENT);
        el.style.removeProperty(NoScrollCssVars.TARGET_PADDING_RIGHT);
      });
    };
    const adjustScrollScrollbarWidth = (target) => {
      asArray(target).forEach((el) => {
        let scrollDisabled = false;
        el.removeAttribute(NoScrollAttrs.SCROLL_SCROLLBAR_WIDTH_ADJUSTMENT);
        if (el.getAttribute(NoScrollAttrs.SCROLL_DISABLED) !== null) {
          scrollDisabled = true;
          el.removeAttribute(NoScrollAttrs.SCROLL_DISABLED);
        }
        el.style.setProperty(NoScrollCssVars.TARGET_SCROLLBAR_WIDTH, `${getScrollbarWidth(el)}px`);
        if (scrollDisabled) {
          el.setAttribute(NoScrollAttrs.SCROLL_DISABLED, "");
        }
        const computedStyle = window.getComputedStyle(el);
        el.style.setProperty(NoScrollCssVars.TARGET_PADDING_RIGHT, computedStyle.paddingRight);
        el.setAttribute(NoScrollAttrs.SCROLL_SCROLLBAR_WIDTH_ADJUSTMENT, "");
      });
    };
    const removeScrollScrollbarWidthAdjustment = (target) => {
      asArray(target).forEach((el) => {
        el.removeAttribute(NoScrollAttrs.SCROLL_SCROLLBAR_WIDTH_ADJUSTMENT);
        el.style.removeProperty(NoScrollCssVars.TARGET_SCROLLBAR_WIDTH);
        el.style.removeProperty(NoScrollCssVars.TARGET_PADDING_RIGHT);
      });
    };
    const updateAllScrollbarWidthAdjustment2 = () => {
      adjustScrollbarWidth2(
        [...document.querySelectorAll(
          attrAsSelector(NoScrollAttrs.SCROLLBAR_WIDTH_ADJUSTMENT)
        )]
      );
      adjustScrollScrollbarWidth(
        [...document.querySelectorAll(
          attrAsSelector(NoScrollAttrs.SCROLL_SCROLLBAR_WIDTH_ADJUSTMENT)
        )]
      );
    };
    const handleWindowResize = throttle(
      updateAllScrollbarWidthAdjustment2,
      (_a = options == null ? void 0 : options.windowResizeThrottle) != null ? _a : DEFAULT_WINDOW_RESIZE_THROTTLE
    );
    const {
      init: initScrollDisable,
      reset: resetScrollDisable
    } = createQueue(
      () => {
        var _a2;
        if (!(options == null ? void 0 : options.noHandleWindowResize)) {
          window.addEventListener("resize", handleWindowResize);
        }
        (_a2 = options == null ? void 0 : options.onInitScrollDisable) == null ? void 0 : _a2.call(options);
      },
      () => {
        var _a2;
        if (!(options == null ? void 0 : options.noHandleWindowResize)) {
          window.removeEventListener("resize", handleWindowResize);
        }
        (_a2 = options == null ? void 0 : options.onResetScrollDisable) == null ? void 0 : _a2.call(options);
      }
    );
    const disableScroll2 = (target, {
      scrollbarWidthAdjustment = true
    } = {}) => {
      var _a2;
      appendGlobalStyles();
      initScrollDisable();
      (_a2 = options == null ? void 0 : options.onScrollDisable) == null ? void 0 : _a2.call(options, target);
      if (scrollbarWidthAdjustment) {
        adjustScrollScrollbarWidth(target);
      }
      target.setAttribute(NoScrollAttrs.SCROLL_DISABLED, "");
    };
    const enableScroll2 = (target) => {
      var _a2;
      if (target.getAttribute(NoScrollAttrs.SCROLL_DISABLED) === null) {
        return;
      }
      resetScrollDisable();
      (_a2 = options == null ? void 0 : options.onScrollEnable) == null ? void 0 : _a2.call(options, target);
      removeScrollScrollbarWidthAdjustment(target);
      target.removeAttribute(NoScrollAttrs.SCROLL_DISABLED);
    };
    const {
      init: disablePageScroll2,
      reset: enablePageScroll2,
      initIsCalled: pageScrollIsDisabled2
    } = createQueue(
      () => disableScroll2(document.body),
      () => enableScroll2(document.body)
    );
    const createPageScrollToggler2 = () => {
      let isDisabled = false;
      const toggler = {
        disablePageScroll() {
          if (isDisabled) {
            return;
          }
          disablePageScroll2();
          isDisabled = true;
        },
        enablePageScroll() {
          if (!isDisabled) {
            return;
          }
          enablePageScroll2();
          isDisabled = false;
        },
        togglePageScroll() {
          if (isDisabled) {
            toggler.enablePageScroll();
          } else {
            toggler.disablePageScroll();
          }
        }
      };
      return toggler;
    };
    const markScrollable2 = (target) => {
      asArray(target).forEach((el) => {
        el.setAttribute(NoScrollAttrs.SCROLLABLE, "");
      });
    };
    const unmarkScrollable2 = (target) => {
      asArray(target).forEach((el) => {
        el.removeAttribute(NoScrollAttrs.SCROLLABLE);
      });
    };
    return {
      adjustScrollbarWidth: adjustScrollbarWidth2,
      removeScrollbarWidthAdjustment: removeScrollbarWidthAdjustment2,
      updateAllScrollbarWidthAdjustment: updateAllScrollbarWidthAdjustment2,
      disableScroll: disableScroll2,
      enableScroll: enableScroll2,
      disablePageScroll: disablePageScroll2,
      enablePageScroll: enablePageScroll2,
      pageScrollIsDisabled: pageScrollIsDisabled2,
      createPageScrollToggler: createPageScrollToggler2,
      markScrollable: markScrollable2,
      unmarkScrollable: unmarkScrollable2
    };
  };
  var {
    adjustScrollbarWidth,
    removeScrollbarWidthAdjustment,
    updateAllScrollbarWidthAdjustment,
    disableScroll,
    enableScroll,
    disablePageScroll,
    enablePageScroll,
    pageScrollIsDisabled,
    createPageScrollToggler,
    markScrollable,
    unmarkScrollable
  } = createNoScroll();

  // node_modules/@fluejs/noscroll/dist/touch.mjs
  var TOUCH_DETECTION_OFFSET = 3;
  var touchState = {
    isPageScrollDisabled: false,
    startTouchY: 0,
    startTouchX: 0
  };
  var querySelectorClosestParent = (fromTarget, selector, matchSelf = true, rootTarget = document) => {
    let current = matchSelf ? fromTarget : fromTarget.parentElement;
    while (current && current !== rootTarget) {
      if (current.matches(selector)) {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  };
  var isScrollableInput = (target) => {
    const selector = 'textarea, [contenteditable="true"]';
    return target.matches(selector);
  };
  var isInputRage = (target) => {
    const selector = 'input[type="range"]';
    return target.matches(selector);
  };
  var hasOverflowHidden = (target) => {
    const computedStyle = getComputedStyle(target);
    return computedStyle.overflow === "hidden";
  };
  var isAtScrollTop = (target) => {
    if (hasOverflowHidden(target)) {
      return true;
    }
    const scrollTop = target.scrollTop;
    return scrollTop <= 0;
  };
  var isAtScrollBottom = (target) => {
    if (hasOverflowHidden(target)) {
      return true;
    }
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const scrollTopWithHeight = scrollTop + target.offsetHeight;
    return scrollTopWithHeight >= scrollHeight;
  };
  var isAtScrollLeft = (target) => {
    if (hasOverflowHidden(target)) {
      return true;
    }
    const scrollLeft = target.scrollLeft;
    return scrollLeft <= 0;
  };
  var isAtScrollRight = (target) => {
    if (hasOverflowHidden(target)) {
      return true;
    }
    const scrollLeft = target.scrollLeft;
    const scrollWidth = target.scrollWidth;
    const scrollLeftWithWidth = scrollLeft + target.offsetWidth;
    return scrollLeftWithWidth >= scrollWidth;
  };
  var onTouchStart = (e) => {
    touchState.isPageScrollDisabled = document.body.matches(attrAsSelector(NoScrollAttrs.SCROLL_DISABLED));
    touchState.startTouchY = e.touches[0].clientY;
    touchState.startTouchX = e.touches[0].clientX;
  };
  var onTouchMove = (e) => {
    if (!touchState.isPageScrollDisabled) {
      return;
    }
    if (e.touches.length > 2) {
      return;
    }
    const { startTouchY, startTouchX } = touchState;
    const currentClientY = e.touches[0].clientY;
    const currentClientX = e.touches[0].clientX;
    const direction = {
      isUp: startTouchY < currentClientY,
      isDown: startTouchY > currentClientY,
      isLeft: startTouchX < currentClientX,
      isRight: startTouchX > currentClientX
    };
    const directionWithOffset = {
      isUp: startTouchY + TOUCH_DETECTION_OFFSET < currentClientY,
      isDown: startTouchY - TOUCH_DETECTION_OFFSET > currentClientY,
      isLeft: startTouchX + TOUCH_DETECTION_OFFSET < currentClientX,
      isRight: startTouchX - TOUCH_DETECTION_OFFSET > currentClientX
    };
    const handle = (el, skip = false) => {
      if (!el) {
        if (e.cancelable) {
          e.preventDefault();
        }
        return;
      }
      if (isInputRage(el)) {
        return;
      }
      const scrollableParent = querySelectorClosestParent(
        el,
        attrAsSelector(NoScrollAttrs.SCROLLABLE),
        false
      );
      if (!(skip || isScrollableInput(el) && querySelectorClosestParent(el, attrAsSelector(NoScrollAttrs.SCROLLABLE)) || el.matches(attrAsSelector(NoScrollAttrs.SCROLLABLE)))) {
        handle(scrollableParent);
        return;
      }
      let prevent = false;
      if (isAtScrollLeft(el) && isAtScrollRight(el)) {
        if (direction.isUp && isAtScrollTop(el) || direction.isDown && isAtScrollBottom(el)) {
          prevent = true;
        }
      } else if (isAtScrollTop(el) && isAtScrollBottom(el)) {
        if (direction.isLeft && isAtScrollLeft(el) || direction.isRight && isAtScrollRight(el)) {
          prevent = true;
        }
      } else if (directionWithOffset.isUp && isAtScrollTop(el) || directionWithOffset.isDown && isAtScrollBottom(el) || directionWithOffset.isLeft && isAtScrollLeft(el) || directionWithOffset.isRight && isAtScrollRight(el)) {
        prevent = true;
      }
      if (prevent) {
        if (scrollableParent) {
          handle(scrollableParent, true);
        } else if (e.cancelable) {
          e.preventDefault();
        }
      }
    };
    handle(e.target);
  };
  var onTouchEnd = () => {
    touchState.startTouchY = 0;
    touchState.startTouchX = 0;
  };
  var initTouchHandler = () => {
    document.addEventListener("touchstart", onTouchStart);
    document.addEventListener("touchmove", onTouchMove, {
      passive: false
    });
    document.addEventListener("touchend", onTouchEnd);
  };
  var resetTouchHandler = () => {
    document.removeEventListener("touchstart", onTouchStart);
    document.removeEventListener("touchmove", onTouchMove);
    document.removeEventListener("touchend", onTouchEnd);
  };

  // entry.mjs
  var sharedNoScroll = createNoScroll({
    onInitScrollDisable: initTouchHandler,
    onResetScrollDisable: resetTouchHandler
  });
  window.sharedScrollLock = {
    disablePageScroll: () => sharedNoScroll.disablePageScroll(),
    enablePageScroll: () => sharedNoScroll.enablePageScroll(),
    pageScrollIsDisabled: () => sharedNoScroll.pageScrollIsDisabled(),
    markScrollable: (el) => sharedNoScroll.markScrollable(el)
  };
})();
